module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_6000.1d238922.png";